import { render, staticRenderFns } from "./AboutMe.vue?vue&type=template&id=9a294226&"
import script from "./AboutMe.vue?vue&type=script&lang=js&"
export * from "./AboutMe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports